// Function to extract and process final state
export const hasFinalState = (content) => {
  try {
    const startMarker = '__FINAL_STATE__';
    const endMarker = '__END_FINAL_STATE__';
    
    const startIndex = content.indexOf(startMarker);
    const endIndex = content.indexOf(endMarker);
    
    if (startIndex === -1 || endIndex === -1) {
      return false;
    }
    
    const jsonString = content.substring(
      startIndex + startMarker.length,
      endIndex
    );
    
    const finalState = JSON.parse(jsonString);
    
    return true;
  } catch (error) {
    console.error('Error extracting FINAL_STATE:', error);
    return false;
  }
};

const extractFinalState = (content) => {
  try {
    const startMarker = '__FINAL_STATE__';
    const endMarker = '__END_FINAL_STATE__';
    
    const startIndex = content.indexOf(startMarker);
    const endIndex = content.indexOf(endMarker);
    
    if (startIndex === -1 || endIndex === -1) {
      return null;
    }
    
    const jsonString = content.substring(
      startIndex + startMarker.length,
      endIndex
    );
    
    const finalState = JSON.parse(jsonString);
    
    // Extract clean content (without __FINAL_STATE__)
    const cleanContent = content.substring(0, startIndex);
    
    return {
      cleanContent,
      finalState
    };
  } catch (error) {
    console.error('Error extracting FINAL_STATE:', error);
    return null;
  }
};

export const getFilesByMimeType = (files) => {
  const audioUrls = [];
  const imageUrls = [];
  const documentUrls = [];
  const videoUrls = [];
  
  if (!Array.isArray(files)) {
    return { audioUrls, imageUrls, documentUrls, videoUrls };
  }
  
  files.forEach(file => {
    if (!file.mime_type || !file.file_url) {
      console.warn('File with incomplete data:', file);
      return;
    }
    
    const mimeType = file.mime_type.toLowerCase();
    
    // Classify by MIME type
    if (mimeType.startsWith('audio/')) {
      audioUrls.push(file.file_url);
    } else if (mimeType.startsWith('image/')) {
      imageUrls.push(file.file_url);
    } else if (mimeType.startsWith('video/')) {
      videoUrls.push(file.file_url);
    } else if (
      mimeType.includes('pdf') ||
      mimeType.includes('document') ||
      mimeType.includes('text') ||
      mimeType.includes('spreadsheet') ||
      mimeType.includes('presentation') ||
      mimeType.includes('msword') ||
      mimeType.includes('officedocument')
    ) {
      documentUrls.push(file.file_url);
    }
  });
  
  return { audioUrls, imageUrls, documentUrls, videoUrls };
};

// Main function updated to process message content
export const processMessageContent = (content) => {
  try {
    // Check if content contains __FINAL_STATE__
    const finalStateData = extractFinalState(content);

    if (finalStateData) {
      // Process files from FINAL_STATE
      const { audioUrls, imageUrls, documentUrls, videoUrls } = 
        getFilesByMimeType(finalStateData.finalState.final_files || []);


      return {
        audioUrls,
        imageUrls,
        documentUrls,
        videoUrls,
        allFiles: finalStateData.finalState.final_files || []
      };
    } else {
      return {
        audioUrls: [], 
        imageUrls: [], 
        documentUrls: [],
        videoUrls: [],
        allFiles: []
      };
    }
  } catch (error) {
    console.error('Error processing message content:', error);
    return {
      audioUrls: [], 
      imageUrls: [], 
      documentUrls: [],
      videoUrls: [],
      allFiles: []
    };
  }
};